/*
 * Copyright 2026 Sony Corporation
 */
import { Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/** Headings, lists, tables and code of the assistant's messages in the colours of the chat; raw HTML is never shown. */
export const Markdown = ({ children }: { children: string }) => (
  <Box
    sx={{
      overflowWrap: 'anywhere',
      '& > :first-child': { mt: 0 },
      '& > :last-child': { mb: 0 },
      '& p': { my: 0.75 },
      '& h1, & h2, & h3, & h4': { fontSize: '0.95rem', fontWeight: 700, color: 'primary.light', mt: 1.5, mb: 0.5 },
      '& strong': { color: 'common.white', fontWeight: 700 },
      '& ul, & ol': { pl: 2.5, my: 0.75 },
      '& li': { my: 0.25 },
      '& li::marker': { color: 'primary.main' },
      '& code': {
        fontFamily: 'monospace',
        fontSize: '0.85em',
        px: 0.5,
        borderRadius: 0.5,
        bgcolor: 'rgba(255, 255, 255, 0.08)',
        color: '#ce9178',
      },
      '& pre': { p: 1, overflowX: 'auto', bgcolor: 'rgba(0, 0, 0, 0.3)', borderRadius: 1 },
      '& pre code': { bgcolor: 'transparent', color: 'inherit', p: 0 },
      '& table': { borderCollapse: 'collapse', width: '100%', my: 1, fontSize: '0.85rem' },
      '& th, & td': { border: 1, borderColor: 'divider', px: 1, py: 0.5, textAlign: 'left', verticalAlign: 'top' },
      '& th': { bgcolor: 'rgba(255, 255, 255, 0.06)', color: 'primary.light' },
      '& blockquote': { m: 0, pl: 1.5, borderLeft: 3, borderColor: 'warning.main', color: 'text.secondary' },
      '& a': { color: 'primary.light' },
      '& hr': { borderColor: 'divider' },
    }}
  >
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noreferrer">
            {children}
          </a>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  </Box>
);
